import { Fragment, useContext, useEffect, useState } from 'react';

import './DetailsPassword.scss';
import { Row, Col, Form } from 'react-bootstrap';

import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import checkMark from '../../../../assets/icons/check-mark.svg';
import GovSpinner from '../../../Form/GovSpinner';
import Toast from '../../../Form/Toast';
import Ajax from '../../../../Handler/Ajax';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import LoginContext from '../../../../store/login-context';

declare function Translate(key: string): string;

const DetailsPassword = props => {

  const ctx = useContext(LoginContext);

  const [controlPassType, setControlPassType] = useState('password');
  const [password, setPassword] = useState('');
  const [isPassValid, setIsPassValid] = useState(false);
  const [passDirty, setPassDirty] = useState(false);
  const [controlConfirmType, setControlConfirmType] = useState('password');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [isPassConfirmValid, setIsPassConfirmValid] = useState(false);
  const [passConfirmDirty, setPassConfirmDirty] = useState(false);
  const [isCharactersLengthValid, setIsCharactersLengthValid] = useState(false);
  const [isCharactersValid, setIsCharactersValid] = useState(false);
  const [isDigitsValid, setIsDigitsValid] = useState(false);
  const [isSpecialCharactersValid, setIsSpecialCharactersValid] = useState(false);
  const [isIdentical, setIsIdentical] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState('');

  useEffect(() => {
    if(password.length > 0 && !passDirty){
      setPassDirty(true);
    }
    if(passwordConfirm.length > 0 && !passConfirmDirty){
      setPassConfirmDirty(true);
    }
  },[password, passwordConfirm])
    
  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[\w\W]{0,128}$/;
    if (regex.test(e.target.value.toString())) {
      setPassword(e.target.value.replace(/\s/g, ''));
      setPasswordConfirm('');
      setIsPassValid(isPasswordValid(e.target.value)); 
            
      if(isPasswordValid(e.target.value)){
        document.getElementById("password")?.setAttribute("aria-invalid","false");
      }
      else{
        document.getElementById("password")?.setAttribute("aria-invalid","true");
      }
    }
  };

  const handlePasswordConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPasswordConfirm(e.target.value);
    setIsPassConfirmValid(isPasswordConfirmValid(e.target.value)); 
       
    if(isPasswordConfirmValid(e.target.value)){
      document.getElementById("passwordConfirm")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("passwordConfirm")?.setAttribute("aria-invalid","true");
    }
  };

  const handlepassEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {      
      sendPassword();
      event.preventDefault();
    }
  };

  const onPasteHandler = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
  };

  const isPasswordValid = (password: string) => {
    passwordLengthValidation(password)
      ? setIsCharactersLengthValid(true)
      : setIsCharactersLengthValid(false);
    
    passwordCharactersValidation(password)
      ? setIsCharactersValid(true)
      : setIsCharactersValid(false);

    passwordDigitValidation(password)
      ? setIsDigitsValid(true)
      : setIsDigitsValid(false);

    passwordSpecialValidation(password)
      ? setIsSpecialCharactersValid(true)
      : setIsSpecialCharactersValid(false);

    identicalCharactersValidation(password)
      ? setIsIdentical(true)
      : setIsIdentical(false);

    return (
      passwordLengthValidation(password) &&
      passwordCharactersValidation(password) &&
      passwordDigitValidation(password) &&
      passwordSpecialValidation(password) &&
      identicalCharactersValidation (password)
    );
  };

  const passwordLengthValidation = (password: string): boolean => {
    return password.length < 8 ? false : true;
  };

  const passwordCharactersValidation = (password: string) => {
    const regex = new RegExp(/(?=.*[a-z])(?=.*[A-Z])/);
    return regex.test(password);
  };

  const passwordDigitValidation = (password: string) => {
    const regex = new RegExp(/[\d]/);
    return regex.test(password);
  };

  const passwordSpecialValidation = (password: string) => {
    const regex = new RegExp(/[\W]/);
    return regex.test(password);
  };

  const identicalCharactersValidation = (password:string) => {
      const regex = new RegExp(/([a-zA-Z0-9])\1\1/);
      return !regex.test(password);
   };
 
  const isPasswordConfirmValid = (passConfirm: string) => {
    return password === passConfirm;
  };
 
  const sendPassword = () => {
    if (!isPassValid || !isPassConfirmValid) return;

    setLoading(true);
    setServerMessage('');
    
    if (ctx.devMode) {
      setLoading(false);
      props.passwordStepCompleted();
    } else {
      Ajax.SendPassword(password)
        .then(() => {
          setLoading(false);
          props.passwordStepCompleted();
        })
        .catch((error) => {
          setLoading(false);
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));          
        });
    }
  };

  const passErrMsg = () => {
    return (`${Translate('N_General_Error_weak_password')}  ${Translate('N_General_Error_weak_password_weak')}`);
  }

  const passValidMsg = () => {
    return (`${Translate('N_General_Error_strong_password')}  ${Translate('N_General_Error_strong_password_strong')}`);
  }

  return (
    <Fragment>
      <GovSpinner show={loading} />

      {serverMessage.length > 0 && (
        <Toast message={serverMessage} />
      )}

      <div className='d-flex flex-row regular dark-blue'>
        {Translate('N_General_SignUp_info_10')}
      </div>
      <div className='d-flex flex-row regular dark-blue font-weight-bold'>
        {Translate('N_Login_Bio_ID_password_stage_info_2')}
      </div>
      <Row className='mb-5'>
        <Col xl={6} lg={6} md={12} sm={12} xs={12} className='passwordInput'>
          <Form className='normal-form'>
            <Row className='mt-3 mb-2'>
              <Form.Group controlId='password' as={Col}>                
                <Form.Label  className='my-1 d-flex align-items-center justify-content-between'>
                    <div>
                      {Translate('N_Login_password_password')}                                            
                    </div>
                    <div 
                      className='mx-2 d-flex align-items-center'
                      aria-hidden="true"
                      onClick={() =>
                        setControlPassType(
                          controlPassType === 'password'
                            ? 'text'
                            : 'password'
                        )
                      }
                    >
                      <img
                        src={controlPassType === 'password' ? eye : eyeOff}
                        width='22px'
                        height='18px'
                        role='button'
                        tabIndex={0}
                        className={
                          password
                            ? 'mx-1 password-view-show'
                            : 'mx-1 password-view-hide'
                        }
                        
                      />
                      <span 
                        className={
                          password
                            ? 'password-view-show'
                            : 'password-view-hide'
                        }
                      >
                        {controlPassType === 'password' 
                          ? Translate('N_General_SignUp_info_18')
                          : Translate('N_General_SignUp_info_19')
                        }
                      </span>                      
                    </div>
                </Form.Label>
                <Form.Control
                  type={controlPassType}
                  value={password}
                  aria-required="true"
                  onChange={handlePassword}
                  onKeyPress={handlepassEnter}
                  onPaste={onPasteHandler}
                  maxLength={20}
                  aria-describedby = "passInstructions passDesc"
                  aria-invalid="false"
                  aria-errormessage="passErr"
                  className={
                    !isPassValid && passDirty
                      ? 'ltrText error-control gov-black'
                      : 'ltrText gov-black'
                  }
                />                
                {isPassValid && (
                  <img
                    src={checkMark}
                    alt=''
                    className='valid-notation'
                    aria-hidden="true"
                  />
                )}
                {passDirty && (
                  <div>
                    {!isPassValid ? (
                      <Form.Text className='error d-flex align-items-start'>
                        <img
                          src={alert}
                          alt=''
                          className='error-alert'
                          aria-hidden="true"
                        />
                        &nbsp;
                        <span className='error-text' id='passErr'>
                          {passErrMsg()}
                        </span>
                      </Form.Text>
                    ) : (
                      <Form.Text className='strong-password'>
                        <span className='py-2' id='passDesc'>
                          {passValidMsg()}
                        </span>
                      </Form.Text>
                    )}
                  </div>
                )}
              </Form.Group>
            </Row>

            <Row className='mb-2'>

              <Form.Group controlId='passwordConfirm' as={Col}>                
                <Form.Label className='my-1 d-flex align-items-center justify-content-between'>
                    <div>
                      {Translate('N_General_SignUp_info_13')}                                            
                    </div>
                    <div 
                      className='mx-2 d-flex align-items-center'
                      aria-hidden="true"
                      onClick={() =>
                        setControlConfirmType(
                          controlConfirmType === 'password'
                            ? 'text'
                            : 'password'
                        )
                      }
                    >
                      <img
                        src={controlConfirmType === 'password' ? eye : eyeOff}
                        width='22px'
                        height='18px'
                        role='button'
                        tabIndex={0}
                        className={
                          passwordConfirm
                            ? 'mx-1 password-view-show'
                            : 'mx-1 password-view-hide'
                        }
                        
                      />
                      <span 
                        className={
                          passwordConfirm
                            ? 'password-view-show'
                            : 'password-view-hide'
                        }
                      >
                        {controlConfirmType === 'password' 
                          ? Translate('N_General_SignUp_info_18')
                          : Translate('N_General_SignUp_info_19')
                        }
                      </span>                      
                    </div>
                </Form.Label>

                <Form.Control
                  type={controlConfirmType}
                  value={passwordConfirm}
                  aria-required="true"
                  onChange={handlePasswordConfirm}
                  onKeyPress={handlepassEnter}
                  onPaste={onPasteHandler}
                  maxLength={20}
                  disabled={!isPassValid}                   
                  aria-invalid="false"
                  aria-errormessage="confirmPassErr"
                  className={
                    !isPassConfirmValid && passConfirmDirty                   
                      ? 'ltrText error-control gov-black'
                      : 'ltrText gov-black'
                  }
                />                
                {isPassConfirmValid && (
                  <img
                    src={checkMark}
                    alt=''
                    className='valid-notation'
                    aria-hidden="true"
                  />
                )}
                {!isPassConfirmValid &&
                  passConfirmDirty && (
                  <Form.Text className='error d-flex align-items-start'>
                    <img src={alert}  className='error-alert' />
                    &nbsp;
                    <span className='error-text' id='confirmPassErr'>
                      {Translate('N_General_Error_fields_dont_match')}
                    </span>
                  </Form.Text>
                )}
              </Form.Group>
            </Row>
            <Row className='mb-3'>
              <Col xs={12}>                  
                <SubmitBtn
                  title={Translate('N_General_next_butten')}
                  id="passwordSubmit"
                  action={sendPassword}
                  showIcon={false}
                  disabled={
                    !isPassValid || !isPassConfirmValid
                  }
                />
              </Col>
            </Row>
          </Form>
        </Col>
        {(!isPassValid || !isPassConfirmValid) && (
          <Col xl={6} lg={6} md={12} sm={12} xs={12} className='passwordInstructions'>
            <div className='instructions mt-4 pe-2 h-100 regular' id='passInstructions'>
              <div className='mt-3 mb-2 dark-blue font-weight-bold'>
                {Translate('N_General_password_must_have')}
              </div>
              <div className='mt-1 instruction-container'>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'instructions-dot'
                        : isCharactersLengthValid
                          ? 'instructions-dot-valid'
                          : 'instructions-dot-error'
                    }
                  ></span>
                </div>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'py-1'
                        : isCharactersLengthValid
                          ? 'py-1'
                          : 'py-1 instructions-text-error'
                    }
                  >
                    {Translate('N_General_password_info_1')}
                  </span>
                </div>
              </div>
              <div className='instruction-container'>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'instructions-dot'
                        : isCharactersValid
                          ? 'instructions-dot-valid'
                          : 'instructions-dot-error'
                    }
                  ></span>
                </div>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'py-1'
                        : isCharactersValid
                          ? 'py-1'
                          : 'py-1 instructions-text-error'
                    }
                  >
                    {Translate('N_General_password_info_2')}
                  </span>
                </div>
              </div>
              <div className='instruction-container'>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'instructions-dot'
                        : isDigitsValid
                          ? 'instructions-dot-valid'
                          : 'instructions-dot-error'
                    }
                  ></span>
                </div>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'py-1'
                        : isDigitsValid
                          ? 'py-1'
                          : 'py-1 instructions-text-error'
                    }
                  >
                    {Translate('N_General_password_info_3')}
                  </span>
                </div>
              </div>
              <div className='instruction-container'>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'instructions-dot'
                        : isSpecialCharactersValid
                          ? 'instructions-dot-valid'
                          : 'instructions-dot-error'
                    }
                  ></span>
                </div>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'py-1'
                        : isSpecialCharactersValid
                          ? 'py-1'
                          : 'py-1 instructions-text-error'
                    }
                  >
                    {Translate('N_General_password_info_4')}
                  </span>
                </div>
              </div>
              <div className='mt-3 mb-2 dark-blue font-weight-bold'>
                {Translate('N_General_wrong_password')}
              </div>
              <div className='instruction-container'>
                <div>
                  <span
                      className={
                        !passDirty
                          ? 'instructions-dot'
                          : isIdentical
                            ? 'instructions-dot-valid'
                            : 'instructions-dot-error'
                      }
                    ></span>
                </div>
                <div>
                  <span
                    className={
                      !passDirty
                        ? 'py-1'
                        : isIdentical
                          ? 'py-1'
                          : 'py-1 instructions-text-error'
                    }
                  >
                    {Translate('N_General_wrong_password_info_2')}
                  </span>
                </div>                
              </div>                           
              <div className='instruction-container'>
                <div aria-hidden="true">
                  <svg className="orengeWarningIcon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19.863 19.863">
                      <g id="info" transform="translate(-2 -2)">
                        <path id="_-Icon-Сolor" data-name="🎨-Icon-Сolor" d="M11.931,9.945a.994.994,0,0,1,.993.993h0V15.9a.993.993,0,1,1-1.986,0h0V10.938A.994.994,0,0,1,11.931,9.945Zm0-2.979a.993.993,0,1,1-.993.993A.994.994,0,0,1,11.931,6.966Zm0,12.911a7.945,7.945,0,1,1,7.945-7.945,7.954,7.954,0,0,1-7.945,7.945M11.931,2a9.931,9.931,0,1,0,9.931,9.931A9.931,9.931,0,0,0,11.931,2" fill="#f1af12"/>
                      </g>
                  </svg>
                </div>
                <div>
                  <span className='py-1'>
                    {Translate('N_General_wrong_password_info_3')}
                  </span>
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </Fragment>
  );

};
export default DetailsPassword;

